import { useEffect, useState } from "react";

const isSupported = () => typeof window !== "undefined" && "Notification" in window;

/**
 * Pede permissão de notificação no primeiro gesto do usuário.
 *
 * O gesto é obrigatório no Safari e, de quebra, é o mesmo evento que destrava a
 * política de autoplay de áudio do navegador — pedir aqui garante que som e
 * popup fiquem liberados juntos.
 *
 * A Notification API só existe em contexto seguro (https ou localhost); em http
 * o hook simplesmente reporta "unsupported".
 */
const useNotificationPermission = () => {
	const [permission, setPermission] = useState(() =>
		isSupported() ? Notification.permission : "unsupported"
	);

	useEffect(() => {
		if (!isSupported() || Notification.permission !== "default") return undefined;

		const requestOnce = () => {
			removeListeners();
			Notification.requestPermission()
				.then(setPermission)
				.catch(() => {});
		};

		function removeListeners() {
			document.removeEventListener("click", requestOnce);
			document.removeEventListener("keydown", requestOnce);
		}

		document.addEventListener("click", requestOnce);
		document.addEventListener("keydown", requestOnce);

		return removeListeners;
	}, []);

	return permission;
};

export default useNotificationPermission;
